import { render, staticRenderFns } from "./widgetFwAppTrafTop10.vue?vue&type=template&id=b349f0b8&scoped=true&"
import script from "./widgetFwAppTrafTop10.vue?vue&type=script&lang=js&"
export * from "./widgetFwAppTrafTop10.vue?vue&type=script&lang=js&"
import style0 from "./widgetFwAppTrafTop10.vue?vue&type=style&index=0&id=b349f0b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b349f0b8",
  null
  
)

export default component.exports